import React from 'react'
import { useMediaQuery } from '@mantine/hooks'
import { Stack, Title, Text, createStyles, Grid, useMantineTheme, Box, List } from '@mantine/core'
import { useTranslation } from 'react-i18next'
import step4_01 from '../../assets/stepper/step4_01_black.png'
import step4_01_white from '../../assets/stepper/step4_01_white.png'
import step4_02 from '../../assets/stepper/step4_02_black.png'
import step4_02_white from '../../assets/stepper/step4_02_white.png'
import step4_03 from '../../assets/stepper/step4_03.png'
import step4_04_black from '../../assets/stepper/step4_04_black.png'
import step4_04_white from '../../assets/stepper/step4_04_white.png'
import IconWrapper from '../MediaWrappers/IconWrapper'

const useStyles = createStyles(theme => ({
  panel: {
    padding: 0,
    flexDirection: 'column',
    height: '100vh',
    justifyContent: 'center',
  },
  info: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    backgroundColor: theme.colors.background[0],
    color: theme.colors.title[0],
    margin: '50px',
  },
  graphicFirst: {
    width: '20vw',
    margin: '4% auto',
    [`@media (max-width: ${theme.breakpoints.lg})`]: {
      width: '300px',
    },
  },
  graphicSecond: {
    width: '20vw',
    margin: '27% auto',
    [`@media (max-width: ${theme.breakpoints.lg})`]: {
      width: '300px',
    },
  },
  graphic: {
    width: '20vw',
    [`@media (max-width: ${theme.breakpoints.lg})`]: {
      width: '500px',
    },
    [`@media (max-width: ${theme.breakpoints.xs})`]: {
      width: '320px',
    },
  },
  textCarousel: {
    fontSize: '18px',
    textAlign: 'center',
    alignContent: 'center',
    marginTop: '1rem',
    [`@media (max-width: ${theme.breakpoints.sm})`]: {
      fontSize: '14px',
    },
  },
}))

const Step4: React.FC = () => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs}`)
  const isDownLg = useMediaQuery(`(max-width: ${theme.breakpoints.lg}`)

  return (
    <Stack className={classes.panel} spacing="1em">
      <Title order={isMobile ? 4 : isDownLg ? 3 : 2} sx={{ margin: '0 auto' }}>
        {t('components.stepper.2.header', 'Right now, you can use the Hub to:')}
      </Title>
      {isDownLg ? (
        <Box sx={{ margin: '0 auto' }}>
          <IconWrapper
            classes={classes.graphicFirst}
            iconDark={step4_01}
            iconLight={step4_01_white}
            loader
            imageLoaderHeight="22vh"
          />
          <List
            style={{
              color: theme.colors.title[0],
              margin: '22px',
              textAlign: 'left',
            }}
          >
            <List.Item>
              {t(
                'components.stepper.2.item3',
                'Create, Collect, Publish, & Store Interoperable Items'
              )}
            </List.Item>
            <List.Item>
              {t(
                'components.stepper.2.item4',
                'Explore Featured Spaces, Creator Tools, & Releases on LAMINA1'
              )}
            </List.Item>
            <List.Item>
              {t(
                'components.stepper.2.item1',
                'Set a Username, Avatar & Establish Your Open Metaverse Identity'
              )}
            </List.Item>
            <List.Item>
              {t(
                'components.stepper.2.item2',
                'Send/Receive L1 Betanet Tokens & Track Your Activity'
              )}
            </List.Item>
          </List>
        </Box>
      ) : (
        <Grid className={classes.info}>
          <Grid.Col span={3}>
            <IconWrapper
              classes={classes.graphic}
              iconDark={step4_03}
              iconLight={step4_03}
              loader
              imageLoaderHeight="22vh"
            />
            <Text sx={{ alignContent: 'center', marginTop: '1rem' }}>
              {t(
                'components.stepper.2.text3',
                'Create, Collect, Publish & Store Interoperable Items (w/ More Coming Soon!)'
              )}
            </Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <IconWrapper
              classes={classes.graphic}
              iconDark={step4_04_black}
              iconLight={step4_04_white}
              loader
              imageLoaderHeight="22vh"
            />
            <Text sx={{ alignContent: 'center', marginTop: '1rem' }}>
              {t(
                'components.stepper.2.text4',
                'Explore Featured Spaces, Creator Tools & Product Releases on LAMINA1'
              )}
            </Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <IconWrapper
              classes={classes.graphicFirst}
              iconDark={step4_01}
              iconLight={step4_01_white}
              loader
              imageLoaderHeight="22vh"
            />
            <Text sx={{ alignContent: 'center', marginTop: '1rem' }}>
              {t(
                'components.stepper.2.text1',
                'Set a Username, Avatar & Establish Your Open Metaverse Identity'
              )}
            </Text>
          </Grid.Col>
          <Grid.Col span={3}>
            <IconWrapper
              classes={classes.graphicSecond}
              iconDark={step4_02}
              iconLight={step4_02_white}
              loader
              imageLoaderHeight="22vh"
            />
            <Text sx={{ alignContent: 'center', marginTop: '1rem' }}>
              {t(
                'components.stepper.2.text2',
                'Send/Receive L1 Betanet Tokens & Track Your Activity Across The Network'
              )}
            </Text>
          </Grid.Col>
        </Grid>
      )}
    </Stack>
  )
}

export default Step4
